var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapPoint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 41,
    viewBox: "0 0 32 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 16.0127C30 19.7713 28.0833 23.3461 26.1149 26.4786C24.6879 28.7496 20.0138 34.4838 17.5506 37.4664C16.7488 38.4371 15.2668 38.4254 14.4782 37.4439C12.0183 34.3818 7.30023 28.4768 5.8859 26.4794C3.94375 23.7367 2 19.7717 2 16.0127C2 8.27371 8.26801 2 16 2C23.732 2 30 8.27371 30 16.0127ZM16 23C19.866 23 23 19.866 23 16C23 12.134 19.866 9 16 9C12.134 9 9 12.134 9 16C9 19.866 12.134 23 16 23Z",
    fill: "#0091DE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 16.0127C32 20.3965 29.7812 24.403 27.8083 27.5427C26.2942 29.9523 21.5105 35.8123 19.0926 38.7399C17.482 40.6902 14.4993 40.6634 12.9191 38.6965C10.4826 35.6636 5.71279 29.6959 4.25366 27.6352C2.20938 24.7482 0 20.3725 0 16.0127C0 7.17085 7.16173 0 16 0C24.8383 0 32 7.17085 32 16.0127ZM16 21C18.7614 21 21 18.7614 21 16C21 13.2386 18.7614 11 16 11C13.2386 11 11 13.2386 11 16C11 18.7614 13.2386 21 16 21ZM26.1149 26.4786C28.0833 23.3461 30 19.7713 30 16.0127C30 8.27371 23.732 2 16 2C8.26801 2 2 8.27371 2 16.0127C2 19.7717 3.94375 23.7367 5.8859 26.4794C7.30023 28.4768 12.0183 34.3818 14.4782 37.4439C15.2668 38.4254 16.7488 38.4371 17.5506 37.4664C20.0138 34.4838 24.6879 28.7496 26.1149 26.4786ZM23 16C23 19.866 19.866 23 16 23C12.134 23 9 19.866 9 16C9 12.134 12.134 9 16 9C19.866 9 23 12.134 23 16Z",
    fill: "#F9FDFB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPoint);
export default __webpack_public_path__ + "static/media/map_point.0d85dcc933ffe65eaf07801399765555.svg";
export { ForwardRef as ReactComponent };